import React from "react";

import { useLabels } from "../../../hooks/useLabels";
import { AlertDialog } from "../../dialog/alert/alert-dialog";
import { labels } from "./labels";

interface IDialogLabels {
	title: eXpress.creator.LabelRequest;
	message: eXpress.creator.LabelRequest;
	ok: eXpress.creator.LabelRequest;
}

export const RejectedPhotosDialog = ({
	open,
	onClose,
	code,
	formatMessage,
}: {
	formatMessage: (msg: string) => string;
	code: string;
	open: boolean;
	onClose(): void;
}) => {
	const { title, message, ok } = (labels as { [key: string]: IDialogLabels })[code];

	const [[titleText, messageText, okText], areLabelsLoading] = useLabels([title, message, ok]);

	return areLabelsLoading ? null : (
		<AlertDialog isOpen={open} ok={okText} title={titleText} onOk={onClose}>
			{messageText ? formatMessage(messageText) : null}
		</AlertDialog>
	);
};
RejectedPhotosDialog.displayName = "RejectedPhotosDialog";
